import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-212d0df0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "reportForm"
};
var _hoisted_2 = {
  class: "hostSummary"
};
var _hoisted_3 = {
  class: "num"
};
var _hoisted_4 = {
  class: "desc"
};
var _hoisted_5 = {
  class: "hostSummary"
};
var _hoisted_6 = {
  class: "box"
};
var _hoisted_7 = {
  class: "tab"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "hostSummary"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_title = _resolveComponent("c-title");
  var _component_van_grid_item = _resolveComponent("van-grid-item");
  var _component_van_grid = _resolveComponent("van-grid");
  var _component_pie_echart = _resolveComponent("pie-echart");
  var _component_c_no_data = _resolveComponent("c-no-data");
  var _component_line_echart = _resolveComponent("line-echart");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_c_title, {
    title: "进料总汇"
  }), _createVNode(_component_van_grid, {
    class: "grid mb-2",
    gutter: 10,
    "column-num": 3
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryData, function (item, index) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: index
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_3, _toDisplayString(item.num), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(item.desc), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_c_title, {
    title: "各平台进料量对比"
  }), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, function (item) {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: _normalizeClass([{
        tabActive: item === _ctx.curTab,
        tabActiveLeft: item === '进料量' && item === _ctx.curTab,
        tabActiveRight: item === '运费' && item === _ctx.curTab
      }, "tabItem"]),
      onClick: function onClick($event) {
        return _ctx.tabClick(item);
      }
    }, _toDisplayString(item), 11, _hoisted_8);
  }), 128))])]), _ctx.categoryFeedingCount.pieData.length ? (_openBlock(), _createBlock(_component_pie_echart, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.categoryFeedingCount)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1,
    text: "暂无数据"
  }))]), _createElementVNode("div", _hoisted_9, [_ctx.outweighOneDay ? (_openBlock(), _createBlock(_component_c_title, {
    key: 0,
    title: "各天进料趋势"
  })) : (_openBlock(), _createBlock(_component_c_title, {
    key: 1,
    title: "各时段进料趋势"
  })), _ctx.categoryPriceCount.lineData.length ? (_openBlock(), _createBlock(_component_line_echart, _normalizeProps(_mergeProps({
    key: 2
  }, _ctx.categoryPriceCount)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 3,
    text: "暂无数据"
  }))])]);
}